import { create } from "zustand";

interface DirtyState {
  dirty: boolean;
  setDirty: (dirty: boolean) => void;
  /** Returns true if it's safe to leave (no changes, or user confirmed). */
  confirmLeave: () => boolean;
}

export const useDirtyStore = create<DirtyState>((set, get) => ({
  dirty: false,
  setDirty: (dirty) => set({ dirty }),
  confirmLeave: () => {
    if (!get().dirty) return true;
    return window.confirm("You have unsaved changes. Leave without saving?");
  },
}));
